import { connect } from 'react-redux'

import {
  closeModal,
  dismissModalMessage
} from '../../../../../common/actions/layout'
import {
  addItemToCart,
  editCartEntry
} from '../../../../../common/actions/user/cart'
import AddItemToCartComponent from './addItemToCart'

const mapStateToProps = state => {
  const { layout: { modalMessages }, common: { currentSite } } = state
  return {
    modalMessages,
    currentSite
  }
}

const mapDispatchToProps = dispatch => {
  return {
    closeModal: () => dispatch(closeModal()),
    addItemToCart: data => dispatch(addItemToCart(data)),
    editCartEntry: (entryID, data) => dispatch(editCartEntry(entryID, data)),
    dismissModalMessage: () => dispatch(dismissModalMessage())
  }
}

const AddItemToCartContainer = connect(mapStateToProps, mapDispatchToProps)(
  AddItemToCartComponent
)

export default AddItemToCartContainer
